var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { memo, useEffect } from 'react';
import styled from 'styled-components';
import { Box, getPaletteColor } from 'pcln-design-system';
import Arrow from '../Arrow';
import useCalendar from '../useCalendar';
import useScroll from '../useScroll';
var Card = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CalendarCard__Card",
  componentId: "sc-bn1nkn-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    position: relative;\n    height: 100%;\n    max-height: 100vh;\n    ", " {\n      ", "\n    }\n    ", ";\n  }\n"], ["\n  &&& {\n    position: relative;\n    height: 100%;\n    max-height: 100vh;\n    ", " {\n      ", "\n    }\n    ", ";\n  }\n"])), function (props) {
  return props.theme.mediaQueries[1];
}, function (props) {
  return !props.isMobile && "\n        box-shadow: ".concat(props.hasBoxShadow ? props.theme.shadows['overlay-lg'] : 'none', ";\n        height: auto;\n      ");
}, function (props) {
  return !props.isMobile ? "background-color: ".concat(getPaletteColor('background.lightest')(props)) : '';
});
var ScrollContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CalendarCard__ScrollContainer",
  componentId: "sc-bn1nkn-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    height: 100%;\n    overflow-y: scroll;\n\n    & > div {\n      height: 100%;\n      max-height: 100vh;\n      ", " {\n        ", "\n      }\n    }\n  }\n"], ["\n  &&& {\n    height: 100%;\n    overflow-y: scroll;\n\n    & > div {\n      height: 100%;\n      max-height: 100vh;\n      ", " {\n        ", "\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.mediaQueries[1];
}, function (props) {
  return !props.isMobile && "\n            overflow: auto;\n        ";
});
var MonthWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CalendarCard__MonthWrapper",
  componentId: "sc-bn1nkn-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: sticky;\n"], ["\n  position: sticky;\n"
/** @public */])));
/** @public */
function CalendarCard(_a) {
  var _b = _a.arrows,
    arrows = _b === void 0 ? true : _b,
    _c = _a.boxShadow,
    boxShadow = _c === void 0 ? true : _c,
    _d = _a.calendarWrapperStyles,
    calendarWrapperStyles = _d === void 0 ? {} : _d,
    children = _a.children,
    isMobile = _a.isMobile,
    _e = _a.monthsToShow,
    monthsToShow = _e === void 0 ? 2 : _e,
    _f = _a.monthWidth,
    monthWidth = _f === void 0 ? 350 : _f,
    roundedCorners = _a.roundedCorners,
    _g = _a.scrollToMonth,
    scrollToMonth = _g === void 0 ? 0 : _g,
    useDefaultFooter = _a.useDefaultFooter,
    keyNavHandler = _a.keyNavHandler,
    setCalendarRef = _a.setCalendarRef;
  var _h = useCalendar(),
    use2024DesignSeti = _h.use2024DesignSeti,
    handleKeyDismiss = _h.handleKeyDismiss;
  var _j = useScroll(),
    disableLeftArrow = _j.disableLeftArrow,
    monthIndex = _j.monthIndex,
    scrollBoxDOMNode = _j.scrollBoxDOMNode,
    scrollContainerDOMNode = _j.scrollContainerDOMNode,
    disableRightArrow = _j.disableRightArrow,
    onArrowFocus = _j.onArrowFocus,
    onScroll = _j.onScroll,
    scrollLeft = _j.scrollLeft,
    scrollRight = _j.scrollRight;
  useEffect(function () {
    document.addEventListener('keydown', handleKeyDismiss);
    return function () {
      document.removeEventListener('keydown', handleKeyDismiss);
    };
  }, []);
  useEffect(function () {
    var _a, _b, _c, _d, _e;
    var monthNode = (_c = (_b = (_a = scrollBoxDOMNode === null || scrollBoxDOMNode === void 0 ? void 0 : scrollBoxDOMNode.current) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c[scrollToMonth];
    if (monthNode && (scrollContainerDOMNode === null || scrollContainerDOMNode === void 0 ? void 0 : scrollContainerDOMNode.current)) {
      scrollContainerDOMNode.current.scrollLeft = (_d = monthNode === null || monthNode === void 0 ? void 0 : monthNode.offsetLeft) !== null && _d !== void 0 ? _d : 0;
      scrollContainerDOMNode.current.scrollTop = (_e = monthNode === null || monthNode === void 0 ? void 0 : monthNode.offsetTop) !== null && _e !== void 0 ? _e : 0;
    }
  }, []);
  var childrenLength = React.Children.count(children) || 1;
  return React.createElement(Box, {
    height: '100%',
    ref: setCalendarRef
  }, React.createElement(Card, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    hasBoxShadow: boxShadow,
    isMobile: isMobile,
    rounded: useDefaultFooter ? 'top' : undefined,
    roundedCorners: roundedCorners,
    width: isMobile ? 1 : [1, 1, monthsToShow * monthWidth]
  }, React.createElement(ScrollContainer, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    "data-testid": 'scroll-wrapper',
    isMobile: isMobile,
    ref: isMobile ? scrollContainerDOMNode : null,
    onScroll: onScroll
  }, React.createElement("div", {
    ref: !isMobile ? scrollContainerDOMNode : null,
    onScroll: onScroll
  }, React.createElement("div", {
    ref: scrollBoxDOMNode
  }, React.createElement(MonthWrapper, __assign({}, calendarWrapperStyles, {
    width: isMobile ? 1 : [1, null, monthWidth * childrenLength],
    overflowY: 'scroll',
    onKeyDown: keyNavHandler,
    "data-testid": 'scroll-container'
  }), children)))), arrows && React.createElement(React.Fragment, null, React.createElement(Arrow, {
    isDisabled: disableLeftArrow,
    isMobile: isMobile,
    isPrev: true,
    monthCount: monthIndex,
    use2024DesignSeti: use2024DesignSeti,
    onClick: scrollLeft
  }), React.createElement(Arrow, {
    isDisabled: disableRightArrow,
    isMobile: isMobile,
    monthCount: monthIndex,
    monthsToShow: monthsToShow,
    use2024DesignSeti: use2024DesignSeti,
    onClick: scrollRight,
    onFocus: onArrowFocus
  }))));
}
export default memo(CalendarCard);
var templateObject_1, templateObject_2, templateObject_3;